import type { AxiosResponse } from 'axios';

export const AxiosResponseConverter = {
  toBlob: (response: AxiosResponse<BlobPart>) => {
    const contentType = response.headers['content-type'];
    return new Blob([response.data], {
      type: typeof contentType === 'string' ? contentType : undefined,
    });
  },
};
